module.exports = __webpack_public_path__ + "img/1.774b9aeb.png";